import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { RCL as useTranslation } from "../../components/RCL";
import { Modal, ModalSizes } from "../../components/Modal";

const ModalConnector = ({ children, contentLabel, ...modalProps }) => {
	const [appRoot, setAppRoot] = useState();

	const labels = {
		content: contentLabel,
		close: useTranslation({ searchKey: "modal-close" }),
	};

	useEffect(() => {
		if (document) {
			setAppRoot(document.getElementById("___gatsby"));
		}
	}, []);

	return (
		<Modal
			appElement={appRoot}
			labels={labels}
			// eslint-disable-next-line react/jsx-props-no-spreading
			{...(!appRoot ? { ariaHideApp: false } : {})}
			// eslint-disable-next-line react/jsx-props-no-spreading
			{...modalProps}>
			{children}
		</Modal>
	);
};

ModalConnector.propTypes = {
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
	contentLabel: PropTypes.string,
};

ModalConnector.defaultProps = {
	contentLabel: "",
};

export { ModalConnector, ModalSizes };
